<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getTableData)" class="refresh-btn">刷新</el-button>
    <!-- 条件查询 -->
    <div class="search">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="会员姓名">
          <el-input v-model="searchForm.memberName" clearable placeholder="请输入会员姓名" />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="searchForm.phone" clearable placeholder="请输入会员手机号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getTableData(1)">查 询</el-button>
          <el-button @click="resetHandle">重 置</el-button>
        </el-form-item>
      </el-form>
      <div class="recharge">
        <el-button v-if="![0,-1].includes(deptId)" type="primary" @click="rechargeHandle($event)">充 值</el-button>
      </div>
      <!-- 会员列表 -->
      <el-table v-loading="loading" :data="tableData" :max-height="tableHeight" border>
        <el-table-column type="index" label="序号" width="60" align="center" fixed="left" />
        <el-table-column prop="memberName" label="姓名" min-width="150" />
        <el-table-column prop="phone" label="电话" min-width="150">
          <template slot-scope="scope">
            <div style="margin-right: 5px;font-weight: bold;">{{ scope.row.phone || '' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="curAmount" label="当前金额（元）" min-width="150" align="right">
          <template slot-scope="scope">
            <div style="margin-right: 5px;font-weight: bold;text-align: right">{{ scope.row.curAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新日期" min-width="200" />
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="![0,-1].includes(deptId)" size="medium" type="primary" @click="rechargeHandle($event, scope.row)">充值</el-button>
            <el-button v-if="![0,-1].includes(deptId)" size="medium" type="danger" plain @click="refundHandle(scope.row)">退费</el-button>
            <el-button size="medium" @click="fundHandle(scope.row)">流水</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination" style="text-align: right;">
        <el-pagination
          class="mt20"
          :total="pageInfo.total"
          :current-page="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next" 
          @current-change="changePageHandle"
        />
      </div>

      <!-- 充值弹框 -->
      <RechargeDialog
        v-model="showRechargeDialog"
        :memberInfo="memberInfo"
        :showAddBtn="!isFromRechargeList"
        @updateOrderNumHandle="updateOrderNumHandle"
        @updateMemberInfoHandle="updateMemberInfoHandle"
        @showPaySuccessDialogHandle="showPaySuccessDialogHandle"
      />

      <!-- 退费弹窗 -->
      <RefundDialog
        v-model="showRefundDialog"
        :memberInfo="memberInfo"
        :accountList="accountList"
        @updateOrderNumHandle="updateOrderNumHandle"
        @showPaySuccessDialogHandle="showPaySuccessDialogHandle"
      />

      <!-- 支付/退费成功 -->
      <PayOrRefundSuccessDialog
        v-model="showPayOrRefundSuccessDialog"
        :orderNum="payOrRefundOrderNum"
        :memberInfo="memberInfo"
        :type="type"
      />

      <!-- 流水弹窗 -->
      <FundDialog
        v-model="showFundDialog"
        :memberInfo="memberInfo"
      />

    </div>
  </div>
</template>

<script>
import { imgArr } from "@/assets/images/img"
import req from '@/utils/request'
import { getUsableRechargeRecord } from '@/api/member'
export default {
  data() {
    return {
      imgArr: imgArr,
      deptId: this.$session.get('deptId'),
      loading: true, // 加载中
      searchForm: { // 查询表单
        memberName: '',
        phone: ''
      },
      pageInfo: {
        pageNum: 1, // 当前页
        pageSize: 10, // 显示条数
        total: 0, // 总条数
      },
      tableData: [], // 会员列表
      tableHeight: 0, // 表格最大高度

      isFromRechargeList: false, // 充值的入口是否来源于会员列表
      showRechargeDialog: false, // 充值弹框状态
      memberInfo: {}, // 会员数据

      // 支付/退费成功弹框
      showPayOrRefundSuccessDialog: false,
      payOrRefundOrderNum: '', // 支付/退费成功订单号
      orderInfo: {},

      // 退费弹窗
      showRefundDialog: false,

      type: '',  // 支付成功/退费成功 pay:支付成功  refund:退费成功

      // 流水弹窗
      showFundDialog: false,
      accountList:[]
    }
  },
  created() {
    const distance = document.documentElement.clientWidth > 1250 ? 300 : 360
    this.tableHeight = document.documentElement.clientHeight - distance
    this.getTableData()
  },
  methods: {
    createMemberInfo() {
      return {
        memberName: null,
        sex: "0",
        year: null,
        month: null,
        day: null,
        birthday: null,
        phone: null,
        source: null,
      }
    },

    // 请求充值列表
    async getTableData(isInit = 0) {
      if (isInit === 1) this.pageInfo.pageNum = 1
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        ...this.searchForm
      }
      this.loading = true
      const { data, code } = await req.get('/wallet/queryAccountBySearch', params)
      if (code == 200) {
        this.tableData = data.items || []
        this.pageInfo.total = data.totalNum || 0
      }

      this.loading = false
    },

    // 获取会员详情
    async getMemberInfo(memberId) {
      const { data, code } = await req.get(`/system/member/${memberId}`)
      if (code == 200 && data && data.memberId) {
        this.$computeAge(data.birthday, data)
        return {
          ...data,
          sex: !data.sex ? '2' : data.sex
        }
      } else {
        return {}
      }
    },

    // 改变页码
    changePageHandle(page) {
      this.pageInfo.pageNum = page
      this.getTableData()
    },
        
    // 充值
    async rechargeHandle(event, itemInfo = {}) {
      this.isFromRechargeList = !!itemInfo.memberId
      this.memberInfo = this.isFromRechargeList ? await this.getMemberInfo(itemInfo.memberId) : this.createMemberInfo()
      this.showRechargeDialog = true
    },

    // 退费
    async refundHandle(itemInfo = {}) {
      const memberInfo = await this.getMemberInfo(itemInfo.memberId)
      this.memberInfo = {...memberInfo}
      await this.getUsableRechargeRecord()
      this.showRefundDialog = true
    },

    updateOrderNumHandle(orderNum = '') {
      this.payOrRefundOrderNum = orderNum
    },

    // 流水
    fundHandle(itemInfo = {}) {
      this.memberInfo = itemInfo
      this.showFundDialog = true
    },

    // 更新会员信息
    updateMemberInfoHandle(memberInfo = {}) {
      this.memberInfo = JSON.parse(JSON.stringify(memberInfo))
    },

    // 展示支付成功弹框
    showPaySuccessDialogHandle(type) {
      this.type = type
      this.showPayOrRefundSuccessDialog = true
      this.getTableData()
    },
    /**
     * 重置
     */
     resetHandle() {
      this.searchForm = {
        memberName: '',
        phone: ''
      }
      this.getTableData(1)
    },
    //查询可退款的充值记录
    async getUsableRechargeRecord() {
      let params = {
        deptId: this.$session.get('deptId'),
        memberId: this.memberInfo.memberId,
      }
      let {code, data } = await getUsableRechargeRecord(params)
      if (code === 200) {
        this.accountList = data || []
      }
    }
  },

  components: {
    RechargeDialog: () => import("./dialog/RechargeDialog"),
    RefundDialog: () => import("./dialog/RefundDialog"),
    PayOrRefundSuccessDialog: () => import("./dialog/PayOrRefundSuccessDialog"),
    FundDialog: () => import("./dialog/FundDialog")
  }
}
</script>

<style lang="less" scoped>
.recharge {
  margin: 4px 0 14px;
}
</style>